import styled from 'styled-components'

const CarouselContainer = styled.div`
  height: 270px;
  background: #ececec;
`
function TopBanner(props) {
  return <CarouselContainer></CarouselContainer>
}

export default TopBanner
